import React, { useEffect, useState } from 'react';
import {
  CRow,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CButton,
  CInputGroup,
  CInputGroupText,
  CModal,
  CModalTitle,
  CModalBody,
  CModalHeader,
  CModalFooter,
} from '@coreui/react';

import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import icons

import adminApi from 'services/adminApi';

import './ScenePasscode.scss';
import AccountDefaultModal from './AccountDefaultModal';

export default function UserDetail() {
  const [userList, setUserList] = useState([]);
  const [editUserDetail, setEditUserDetail] = useState({
    username: '',
    password: '',
    userId: '',
  });
  const [errors, setErrors] = useState({
    username: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleOpenConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // Function to close modal
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    async function fetchUserList() {
      const res = await adminApi({ url: '/user' });
      const { isSuccess, data } = await res.json();
      if (isSuccess) {
        setUserList(data || []);
        if (data?.length > 0) {
          setEditUserDetail({
            username: data[0].email || '',
            password: '',
            userId: data[0].id || '',
          });
        }
      }
    }
    fetchUserList();
  }, []);

  const handleSave = async () => {
    const formData = {
      email: editUserDetail.username,
      password: editUserDetail.password,
    };

    const res = await adminApi({
      url: `/user/${editUserDetail.userId}`,
      method: 'PUT',
      body: formData,
    });

    const { isSuccess, message } = await res.json();

    if (!isSuccess) {
      alert(message);
      return;
    }

    setUserList((prevList) =>
      prevList.map((user) =>
        user.id === editUserDetail.userId
          ? { ...user, email: editUserDetail.username }
          : user
      )
    );

    setTimeout(() => {
      handleCancel();
    }, 10);

    setTimeout(() => {
      alert('User is updated successfully');
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      window.location.href = '/login';
    }, 300);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = '';

    if (name === 'username') {
      if (/\s/.test(value)) {
        error = 'Username must not contain spaces.';
      } else if (value.length < 6 || value.length > 25) {
        error = 'Username must be between 6 and 25 characters.';
      }
    } else if (name === 'password') {
      if (/\s/.test(value)) {
        error = 'Password must not contain spaces.';
      } else if (value.length < 6 || value.length > 12) {
        error = 'Password must be between 6 and 12 characters.';
      }
    }

    setEditUserDetail((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const isSaveDisabled =
    Object.values(errors).some((error) => error) ||
    !editUserDetail.username ||
    !editUserDetail.password;

  return (
    <div
      className="user-detail-container"
      style={{
        marginTop: '20px',
        padding: '15px 25px',
        backgroundColor: 'white',
        borderRadius: '5px',
      }}
    >
      <CForm>
        {userList.length > 0 ? (
          <>
            {/* Username */}
            <CRow className="align-items-center mb-3">
              <CCol md={2} className="user-row">
                <CFormLabel className="user-username" htmlFor="username">
                  Username
                </CFormLabel>
              </CCol>
              <CCol md={10}>
                <CFormInput
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter username"
                  value={editUserDetail.username}
                  onChange={handleChange}
                  invalid={!!errors.username}
                />

                {errors.username && (
                  <div className="text-danger" style={{ marginTop: 5 }}>
                    {errors.username}
                  </div>
                )}
              </CCol>
            </CRow>

            {/* Password */}
            <CRow className="align-items-center mb-3">
              <CCol md={2} className="user-row">
                <CFormLabel className="user-password" htmlFor="password">
                  Password
                </CFormLabel>
              </CCol>
              <CCol md={10}>
                <CInputGroup>
                  <CFormInput
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    placeholder="Enter password"
                    value={editUserDetail.password}
                    onChange={handleChange}
                    invalid={!!errors.password}
                  />
                  <CInputGroupText
                    onClick={handleTogglePassword}
                    style={{ cursor: 'pointer' }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </CInputGroupText>
                </CInputGroup>
                {errors.password && (
                  <div className="text-danger" style={{ marginTop: 5 }}>
                    {errors.password}
                  </div>
                )}
              </CCol>
            </CRow>

            <div className="user-actions">
              <CRow className="justify-content-between">
                <CCol md={2} xs={6}>
                  <CButton
                    color="secondary"
                    onClick={handleOpenModal}
                    style={{ width: 'auto', whiteSpace: 'nowrap' }}
                  >
                    Default Account
                  </CButton>
                </CCol>
                <CCol md={2} xs={5}>
                  <CButton
                    color="primary"
                    onClick={handleOpenConfirmModal} // Mở modal xác nhận
                    disabled={isSaveDisabled}
                    style={{ width: '100%' }}
                  >
                    Save
                  </CButton>
                </CCol>
              </CRow>
            </div>
          </>
        ) : (
          <p>Loading user data...</p>
        )}
      </CForm>

      <CModal visible={isConfirmModalOpen} onClose={handleCloseConfirmModal}>
        <CModalHeader>
          <CModalTitle>Confirm Save</CModalTitle>
        </CModalHeader>
        <CModalBody>Are you sure you want to save the changes?</CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={handleCloseConfirmModal}>
            No
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              handleSave();
              handleCloseConfirmModal();
            }}
          >
            Yes
          </CButton>
        </CModalFooter>
      </CModal>

      <AccountDefaultModal
        userId={editUserDetail.userId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
}
